import { RoundButton } from "../../../../../assets/styles/RoudeButton";
import { Modal } from "../../../../../components/Modal";

import sendIcon from "../../../../../assets/imgs/send_icon.svg";
import { zodResolver } from "@hookform/resolvers/zod";
import { SubmitHandler, useForm } from "react-hook-form";
import { z } from "zod";
import { Dispatch, SetStateAction, useContext, useRef, useState } from "react";
import { ImageCarousel } from "../../../../../components/ImageCarousel/ImageCarousel";
import { PostContext } from "../../../../../providers/PostContext";

const createPostSchema = z.object({
	images: z.array(z.instanceof(File)).optional(),
	message: z.string(),
});

type iCreatePostData = {
	images: File[];
	message: string;
};

export const CreatePostModal = ({
	setShowCreatePost,
}: {
	setShowCreatePost: Dispatch<SetStateAction<boolean>>;
}) => {
	const { createPost } = useContext(PostContext);

	const [avatarURLs, setAvatarURLs] = useState<
		{ id: number; url: string }[] | []
	>([]),
		fileUploadRef = useRef<HTMLInputElement | null>(null);

	const {
		register,
		handleSubmit,
		setValue,
		formState: { errors },
	} = useForm<iCreatePostData>({
		resolver: zodResolver(createPostSchema),
	});

	const submitCreatePost: SubmitHandler<iCreatePostData> = async (
		createPostData
	) => {
		createPost(createPostData);
		setShowCreatePost(false);
	};

	const handleImageUpload = (
		event: React.MouseEvent<HTMLButtonElement, MouseEvent>
	) => {
		event.preventDefault();
		if (fileUploadRef.current) {
			fileUploadRef.current.click();
		}
	};

	const uploadImageDisplay = () => {
		if (fileUploadRef.current && fileUploadRef.current.files) {
			const uploadedFiles = Array.from(fileUploadRef.current.files);

			setValue("images", uploadedFiles);

			const cachedURLs = uploadedFiles.map((file) => URL.createObjectURL(file));
			const newUrlsObjectArray = cachedURLs.map((url, i) => {
				return { id: i, url };
			});
			setAvatarURLs(newUrlsObjectArray);
		}
	};

	return (
		<Modal showModal={setShowCreatePost}>
			<div className="model-image">
				<form
					encType="multipart/form-data"
					onSubmit={handleSubmit(submitCreatePost)}
				>
					<div className="model-image-container">
						<div className="uploaded-images">
							{avatarURLs.length !== 0 && <ImageCarousel images={avatarURLs} />}
						</div>
						<abbr title="Adicionar imagem">
							<button type="button" className="add-img" onClick={handleImageUpload}>
								add img
							</button>
						</abbr>
					</div>
					<input
						type="file"
						ref={fileUploadRef}
						onChange={uploadImageDisplay}
						multiple
						hidden
					/>
					<div className="model-footer">
						<div className="message">
							<input type="text" {...register("message")} alt="Mensagem do post" />
						</div>
						<abbr title="Publicar post">
							<RoundButton type="submit">
								<img src={sendIcon} alt="send icon" />
							</RoundButton>
						</abbr>
					</div>
				</form>
			</div>
		</Modal>
	);
};
